<template>
<v-select
    :items="items"
    :value="value"
    v-on:change="onChange"
    :label="label"
/>
</template>

<script>
export default {
    props: {
        value: {
            type: String,
            default: function() { return null; }
        },

        label: {
            type: String,
            default: function() { return null; }
        },
    },

    data() {
        return {
            items: [
                { 'value' : 'USD', 'text' : 'USD: United States dollar'},
                { 'value' : 'CAD', 'text' : 'CAD: Canadian dollar'},
            ],
        }
    },

    methods: {
        onChange(value) {
            this.$emit('input',value);
        }
    },
}
</script>

<style lang="scss" scoped>

</style>